module.exports = __webpack_public_path__ + "static/media/back.344e96d3.png";